import { render, staticRenderFns } from "./VDateField.vue?vue&type=template&id=1b65b6c4&scoped=true&lang=pug"
import script from "./VDateField.vue?vue&type=script&lang=js"
export * from "./VDateField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b65b6c4",
  null
  
)

export default component.exports